import { createApi } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config/config';
import { baseQueryWithInterceptor } from '../../utils/baseQueryWithInterceptor';
import { ProfileScoreResponse } from '../../../interfaces/gamification.interface';

const gamificationApi = createApi({
  reducerPath: 'gamificationApi',
  baseQuery: baseQueryWithInterceptor(
    `${config.API_BASE_URL}/gamification`
  ),
  tagTypes: ['gamification'],

  endpoints: builder => ({
    getMyGamification: builder.query<ProfileScoreResponse, void>({
      query: () => `/`,
      providesTags: ['gamification'],
    }),
  }),
});

export const { useGetMyGamificationQuery } = gamificationApi;

export default gamificationApi;
